// Testo di ricerca dei Lead: normalizzazione e suddivisione della ricerca digitata, pure e senza I/O.
import { phoneSearchDigits } from "./phones.js";
const COMBINING_MARKS = /[\u0300-\u036f]/g;
const OUTSIDE_SEARCH_ALPHABET = /[^a-z0-9@._+-]+/g;
const PHONE_LIKE_QUERY = /^[\d\s+.\-()]+$/;
const MIN_PHONE_QUERY_DIGITS = 4;
/** Toglie accenti e maiuscole; ogni carattere fuori da lettere, cifre e `@._+-` diventa uno spazio. */
export function normalizeSearchText(value) {
    if (typeof value !== "string")
        return "";
    return value
        .normalize("NFD")
        .replace(COMBINING_MARKS, "")
        .toLowerCase()
        .replace(OUTSIDE_SEARCH_ALPHABET, " ")
        .trim();
}
/** Il testo su cui si cerca un Lead, fatto soltanto dei suoi dati: nomi, email, luogo e cifre dei telefoni. */
export function buildLeadSearchText(input) {
    const parts = [
        input.firstName,
        input.lastName,
        input.salonName,
        input.secondHolderFirstName,
        input.secondHolderLastName,
        ...(input.emails ?? []),
        input.place?.cityName,
        input.place?.provinceName,
        input.place?.provinceAbbreviation,
        input.place?.regionName,
        input.place?.countryName,
        ...(input.phones ?? []).flatMap(phoneSearchDigits),
    ];
    return parts
        .map((part) => normalizeSearchText(part ?? ""))
        .filter(Boolean)
        .join(" ");
}
/**
 * Una ricerca fatta soltanto di cifre e separatori da telefono (almeno quattro cifre, contate senza "+" e senza
 * "00" iniziale) è un solo token di cifre, senza "+" e senza "00" iniziale; ogni altra ricerca diventa parole normalizzate.
 */
export function searchTokens(query) {
    const text = typeof query === "string" ? query : "";
    if (PHONE_LIKE_QUERY.test(text)) {
        const allDigits = text.replace(/\D/g, "");
        const digits = allDigits.startsWith("00") ? allDigits.slice(2) : allDigits;
        if (digits.length >= MIN_PHONE_QUERY_DIGITS)
            return [{ kind: "digits", value: digits }];
    }
    return normalizeSearchText(text)
        .split(" ")
        .filter(Boolean)
        .map((value) => ({ kind: "text", value }));
}
//# sourceMappingURL=search-text.js.map